import { Component, OnInit } from '@angular/core';
import{ FormBuilder,Validators } from '@angular/forms';
import { AppService } from '../app.service';
import { environment } from "src/environments/environment";
import { Router} from "@angular/router";

declare var gtag;
declare var fbq;
@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  constructor(private service:AppService,private fb:FormBuilder,private router: Router) { }

  ngOnInit() {
    if(environment.production){
    this.service.sendEvents("Completecontact", "contact", "Contact");

    fbq('track', "CompleteContact" , {
      content_type: "contact",
      content_title: this.router.url,
    });
  }

    this.service.setTitle('Propira Contact Details');
    this.service.setMetaTags({ property: "og:title", content: 'Propira Contact Details' });
    this.service.setMetaTags({ name: "keywords", content: '' });
    this.service.setMetaTags({ name: "description", content: 'Fill out the simple contact form to buy, rent or sell property and our executives will contact you shortly - Propira.com' });
    this.service.setMetaTags({ property: "og:description", content: 'Fill out the simple contact form to buy, rent or sell property and our executives will contact you shortly - Propira.com' });

    this.getStateList();
  }



  stateList=[]
  getStateList(){ 
    this.service.get('/stateList').subscribe(
      (data:any)=>{
        if(data[0].error=='0'){
          this.stateList=data[0].result; 
        }
      }
    )
  }

  cityList=[];
  getCityList(stateId){ 
    this.cityList=[];
    this.service.post('/getCityNameByState',{"state_id":stateId}).subscribe(
      (data:any)=>{
        if(data[0].error=='0'){
          this.cityList=data[0].result
        }else{
          this.cityList=[];
        }
      },error=>{
        console.log('in error');
        this.cityList=[];
      }
    )
  }

  contact=this.fb.group({
    name:['',Validators.required],
    email:['',[Validators.required,Validators.email]],
    phone:['',[Validators.required,Validators.pattern(/^[6-9]\d{9}$/)]],
    state_id:['',Validators.required],
    city_id:['',Validators.required],
    message:['',Validators.required],
    //terms:['',Validators.required],
  })
 
  get contactControl(){ return this.contact.controls; }
 
  contactSubmit:boolean=false;
  contactLoader:boolean=false;
  contactErrorMsg:string="";
  contactSuccessMsg:string="";
  contactEnd(){
    this.contactErrorMsg="";
    this.contactSuccessMsg="";
    this.contactSubmit=true;
    
    if(this.contact.valid){
      this.contactLoader=true;
      this.service.post('/contactEnd',this.contact.value).subscribe(
        (data:any)=>{
          if(data[0].error=='0'){
             this.contactSuccessMsg=data[0].msg;
             this.contact.reset();
             this.contact.patchValue({"state_id":'',"city_id":''});
             this.contactSubmit=false;
          }else{ 
            this.contactErrorMsg=data[0].msg;
          }
 
          this.contactLoader=false;
        },(error:any)=>{
          this.contactErrorMsg=error.errorDesc;
          this.contactLoader=false;
        }
      )
    }
  }

  numberOnly(event, length = 0, pointAllow = 0) {
    const iKeyCode = (event.which) ? event.which : event.keyCode;
    if ((pointAllow == 1 && (iKeyCode != 46 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57))) || (pointAllow == 0 && (iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57)))) {
      return false;
    } else if (length > 0) {
      var valueLength = (event.target.value).length;
      if (valueLength >= length) {
        return false;
      }
    } else {
      return true;
    }
  }

  validateAlpha(evt){
    var keyCode = (evt.which) ? evt.which : evt.keyCode
    if ((keyCode < 65 || keyCode > 90) && (keyCode < 97 || keyCode > 123) && keyCode != 10  && keyCode != 32 && keyCode != 8 && keyCode != 9)

    return false;
    return true;
  }

}
